/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PartnerLoginImport } from './routes/partner-login'
import { Route as LoginImport } from './routes/login'
import { Route as LinkImport } from './routes/link'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as RegisterPartnerIndexImport } from './routes/register-partner/index'
import { Route as RegisterPartnerThankYouImport } from './routes/register-partner/thank-you'
import { Route as AuthRegisterImport } from './routes/_auth/register'
import { Route as AuthOrdersImport } from './routes/_auth/orders'
import { Route as AuthCheckoutErrorImport } from './routes/_auth/checkout-error'
import { Route as AuthCheckoutCompleteImport } from './routes/_auth/checkout-complete'
import { Route as AuthChargeErrorImport } from './routes/_auth/charge-error'
import { Route as AuthChargeCompleteImport } from './routes/_auth/charge-complete'
import { Route as AuthPartnerIndexImport } from './routes/_auth/partner_/index'
import { Route as AuthPartnerTermsConfirmedImport } from './routes/_auth/partner_/terms-confirmed'
import { Route as AuthPartnerProfileImport } from './routes/_auth/partner_/profile'
import { Route as AuthPartnerOrdersImport } from './routes/_auth/partner_/orders'
import { Route as AuthOfferOfferIdImport } from './routes/_auth/offer_.$offerId'
import { Route as AuthPartnerOrderOrderIdImport } from './routes/_auth/partner_/order_.$orderId'
import { Route as AuthOrderOrderIdOrderImport } from './routes/_auth/order_.$orderId/_order'
import { Route as AuthOfferOfferIdCheckoutImport } from './routes/_auth/offer_.$offerId_.checkout'
import { Route as AuthOrderOrderIdOrderIndexImport } from './routes/_auth/order_.$orderId/_order/index'
import { Route as AuthOrderOrderIdOrderSubmittedImport } from './routes/_auth/order_.$orderId/_order/submitted'
import { Route as AuthOrderOrderIdOrderPayImport } from './routes/_auth/order_.$orderId/_order/pay'
import { Route as AuthOrderOrderIdOrderOpenImport } from './routes/_auth/order_.$orderId/_order/open'
import { Route as AuthOrderOrderIdOrderDraftImport } from './routes/_auth/order_.$orderId/_order/draft'
import { Route as AuthOrderOrderIdOrderConfirmImport } from './routes/_auth/order_.$orderId/_order/confirm'
import { Route as AuthOrderOrderIdOrderCompletedImport } from './routes/_auth/order_.$orderId/_order/completed'
import { Route as AuthOrderOrderIdOrderClosedImport } from './routes/_auth/order_.$orderId/_order/closed'
import { Route as AuthOrderOrderIdOrderItemsRoomsImport } from './routes/_auth/order_.$orderId/_order/items_/rooms'
import { Route as AuthOrderOrderIdOrderItemsCategoriesImport } from './routes/_auth/order_.$orderId/_order/items_/categories'
import { Route as AuthOrderOrderIdOrderDraftSummaryImport } from './routes/_auth/order_.$orderId/_order/_draft/summary'
import { Route as AuthOrderOrderIdOrderDraftItemsImport } from './routes/_auth/order_.$orderId/_order/_draft/items'
import { Route as AuthOrderOrderIdOrderDraftDepartImport } from './routes/_auth/order_.$orderId/_order/_draft/depart'
import { Route as AuthOrderOrderIdOrderDraftDateImport } from './routes/_auth/order_.$orderId/_order/_draft/date'
import { Route as AuthOrderOrderIdOrderDraftBoxesImport } from './routes/_auth/order_.$orderId/_order/_draft/boxes'
import { Route as AuthOrderOrderIdOrderDraftArriveImport } from './routes/_auth/order_.$orderId/_order/_draft/arrive'
import { Route as AuthOrderOrderIdOrderItemsRoomsRoomImport } from './routes/_auth/order_.$orderId/_order/items_/rooms_.room'
import { Route as AuthOrderOrderIdOrderItemsCategoriesCategoryImport } from './routes/_auth/order_.$orderId/_order/items_/categories_.category'

// Create Virtual Routes

const AuthOrderOrderIdImport = createFileRoute('/_auth/order/$orderId')()

// Create/Update Routes

const PartnerLoginRoute = PartnerLoginImport.update({
  path: '/partner-login',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LinkRoute = LinkImport.update({
  path: '/link',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const RegisterPartnerIndexRoute = RegisterPartnerIndexImport.update({
  path: '/register-partner/',
  getParentRoute: () => rootRoute,
} as any)

const RegisterPartnerThankYouRoute = RegisterPartnerThankYouImport.update({
  path: '/register-partner/thank-you',
  getParentRoute: () => rootRoute,
} as any)

const AuthRegisterRoute = AuthRegisterImport.update({
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOrdersRoute = AuthOrdersImport.update({
  path: '/orders',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCheckoutErrorRoute = AuthCheckoutErrorImport.update({
  path: '/checkout-error',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCheckoutCompleteRoute = AuthCheckoutCompleteImport.update({
  path: '/checkout-complete',
  getParentRoute: () => AuthRoute,
} as any)

const AuthChargeErrorRoute = AuthChargeErrorImport.update({
  path: '/charge-error',
  getParentRoute: () => AuthRoute,
} as any)

const AuthChargeCompleteRoute = AuthChargeCompleteImport.update({
  path: '/charge-complete',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOrderOrderIdRoute = AuthOrderOrderIdImport.update({
  path: '/order/$orderId',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPartnerIndexRoute = AuthPartnerIndexImport.update({
  path: '/partner/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPartnerTermsConfirmedRoute = AuthPartnerTermsConfirmedImport.update({
  path: '/partner/terms-confirmed',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPartnerProfileRoute = AuthPartnerProfileImport.update({
  path: '/partner/profile',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPartnerOrdersRoute = AuthPartnerOrdersImport.update({
  path: '/partner/orders',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOfferOfferIdRoute = AuthOfferOfferIdImport.update({
  path: '/offer/$offerId',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPartnerOrderOrderIdRoute = AuthPartnerOrderOrderIdImport.update({
  path: '/partner/order/$orderId',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOrderOrderIdOrderRoute = AuthOrderOrderIdOrderImport.update({
  id: '/_order',
  getParentRoute: () => AuthOrderOrderIdRoute,
} as any)

const AuthOfferOfferIdCheckoutRoute = AuthOfferOfferIdCheckoutImport.update({
  path: '/offer/$offerId/checkout',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOrderOrderIdOrderIndexRoute = AuthOrderOrderIdOrderIndexImport.update(
  {
    path: '/',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any,
)

const AuthOrderOrderIdOrderSubmittedRoute =
  AuthOrderOrderIdOrderSubmittedImport.update({
    path: '/submitted',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderPayRoute = AuthOrderOrderIdOrderPayImport.update({
  path: '/pay',
  getParentRoute: () => AuthOrderOrderIdOrderRoute,
} as any)

const AuthOrderOrderIdOrderOpenRoute = AuthOrderOrderIdOrderOpenImport.update({
  path: '/open',
  getParentRoute: () => AuthOrderOrderIdOrderRoute,
} as any)

const AuthOrderOrderIdOrderDraftRoute = AuthOrderOrderIdOrderDraftImport.update(
  {
    path: '/draft',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any,
)

const AuthOrderOrderIdOrderConfirmRoute =
  AuthOrderOrderIdOrderConfirmImport.update({
    path: '/confirm',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderCompletedRoute =
  AuthOrderOrderIdOrderCompletedImport.update({
    path: '/completed',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderClosedRoute =
  AuthOrderOrderIdOrderClosedImport.update({
    path: '/closed',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderItemsRoomsRoute =
  AuthOrderOrderIdOrderItemsRoomsImport.update({
    path: '/items/rooms',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderItemsCategoriesRoute =
  AuthOrderOrderIdOrderItemsCategoriesImport.update({
    path: '/items/categories',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderDraftSummaryRoute =
  AuthOrderOrderIdOrderDraftSummaryImport.update({
    path: '/summary',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderDraftItemsRoute =
  AuthOrderOrderIdOrderDraftItemsImport.update({
    path: '/items',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderDraftDepartRoute =
  AuthOrderOrderIdOrderDraftDepartImport.update({
    path: '/depart',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderDraftDateRoute =
  AuthOrderOrderIdOrderDraftDateImport.update({
    path: '/date',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderDraftBoxesRoute =
  AuthOrderOrderIdOrderDraftBoxesImport.update({
    path: '/boxes',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderDraftArriveRoute =
  AuthOrderOrderIdOrderDraftArriveImport.update({
    path: '/arrive',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderItemsRoomsRoomRoute =
  AuthOrderOrderIdOrderItemsRoomsRoomImport.update({
    path: '/items/rooms/room',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

const AuthOrderOrderIdOrderItemsCategoriesCategoryRoute =
  AuthOrderOrderIdOrderItemsCategoriesCategoryImport.update({
    path: '/items/categories/category',
    getParentRoute: () => AuthOrderOrderIdOrderRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/link': {
      id: '/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof LinkImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/partner-login': {
      id: '/partner-login'
      path: '/partner-login'
      fullPath: '/partner-login'
      preLoaderRoute: typeof PartnerLoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/charge-complete': {
      id: '/_auth/charge-complete'
      path: '/charge-complete'
      fullPath: '/charge-complete'
      preLoaderRoute: typeof AuthChargeCompleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/charge-error': {
      id: '/_auth/charge-error'
      path: '/charge-error'
      fullPath: '/charge-error'
      preLoaderRoute: typeof AuthChargeErrorImport
      parentRoute: typeof AuthImport
    }
    '/_auth/checkout-complete': {
      id: '/_auth/checkout-complete'
      path: '/checkout-complete'
      fullPath: '/checkout-complete'
      preLoaderRoute: typeof AuthCheckoutCompleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/checkout-error': {
      id: '/_auth/checkout-error'
      path: '/checkout-error'
      fullPath: '/checkout-error'
      preLoaderRoute: typeof AuthCheckoutErrorImport
      parentRoute: typeof AuthImport
    }
    '/_auth/orders': {
      id: '/_auth/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AuthOrdersImport
      parentRoute: typeof AuthImport
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterImport
      parentRoute: typeof AuthImport
    }
    '/register-partner/thank-you': {
      id: '/register-partner/thank-you'
      path: '/register-partner/thank-you'
      fullPath: '/register-partner/thank-you'
      preLoaderRoute: typeof RegisterPartnerThankYouImport
      parentRoute: typeof rootRoute
    }
    '/register-partner/': {
      id: '/register-partner/'
      path: '/register-partner'
      fullPath: '/register-partner'
      preLoaderRoute: typeof RegisterPartnerIndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth/offer/$offerId': {
      id: '/_auth/offer/$offerId'
      path: '/offer/$offerId'
      fullPath: '/offer/$offerId'
      preLoaderRoute: typeof AuthOfferOfferIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/partner/orders': {
      id: '/_auth/partner/orders'
      path: '/partner/orders'
      fullPath: '/partner/orders'
      preLoaderRoute: typeof AuthPartnerOrdersImport
      parentRoute: typeof AuthImport
    }
    '/_auth/partner/profile': {
      id: '/_auth/partner/profile'
      path: '/partner/profile'
      fullPath: '/partner/profile'
      preLoaderRoute: typeof AuthPartnerProfileImport
      parentRoute: typeof AuthImport
    }
    '/_auth/partner/terms-confirmed': {
      id: '/_auth/partner/terms-confirmed'
      path: '/partner/terms-confirmed'
      fullPath: '/partner/terms-confirmed'
      preLoaderRoute: typeof AuthPartnerTermsConfirmedImport
      parentRoute: typeof AuthImport
    }
    '/_auth/partner/': {
      id: '/_auth/partner/'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof AuthPartnerIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/offer/$offerId/checkout': {
      id: '/_auth/offer/$offerId/checkout'
      path: '/offer/$offerId/checkout'
      fullPath: '/offer/$offerId/checkout'
      preLoaderRoute: typeof AuthOfferOfferIdCheckoutImport
      parentRoute: typeof AuthImport
    }
    '/_auth/order/$orderId': {
      id: '/_auth/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof AuthOrderOrderIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/order/$orderId/_order': {
      id: '/_auth/order/$orderId/_order'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof AuthOrderOrderIdOrderImport
      parentRoute: typeof AuthOrderOrderIdRoute
    }
    '/_auth/partner/order/$orderId': {
      id: '/_auth/partner/order/$orderId'
      path: '/partner/order/$orderId'
      fullPath: '/partner/order/$orderId'
      preLoaderRoute: typeof AuthPartnerOrderOrderIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/order/$orderId/_order/closed': {
      id: '/_auth/order/$orderId/_order/closed'
      path: '/closed'
      fullPath: '/order/$orderId/closed'
      preLoaderRoute: typeof AuthOrderOrderIdOrderClosedImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/completed': {
      id: '/_auth/order/$orderId/_order/completed'
      path: '/completed'
      fullPath: '/order/$orderId/completed'
      preLoaderRoute: typeof AuthOrderOrderIdOrderCompletedImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/confirm': {
      id: '/_auth/order/$orderId/_order/confirm'
      path: '/confirm'
      fullPath: '/order/$orderId/confirm'
      preLoaderRoute: typeof AuthOrderOrderIdOrderConfirmImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/draft': {
      id: '/_auth/order/$orderId/_order/draft'
      path: '/draft'
      fullPath: '/order/$orderId/draft'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/open': {
      id: '/_auth/order/$orderId/_order/open'
      path: '/open'
      fullPath: '/order/$orderId/open'
      preLoaderRoute: typeof AuthOrderOrderIdOrderOpenImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/pay': {
      id: '/_auth/order/$orderId/_order/pay'
      path: '/pay'
      fullPath: '/order/$orderId/pay'
      preLoaderRoute: typeof AuthOrderOrderIdOrderPayImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/submitted': {
      id: '/_auth/order/$orderId/_order/submitted'
      path: '/submitted'
      fullPath: '/order/$orderId/submitted'
      preLoaderRoute: typeof AuthOrderOrderIdOrderSubmittedImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/': {
      id: '/_auth/order/$orderId/_order/'
      path: '/'
      fullPath: '/order/$orderId/'
      preLoaderRoute: typeof AuthOrderOrderIdOrderIndexImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/_draft/arrive': {
      id: '/_auth/order/$orderId/_order/_draft/arrive'
      path: '/arrive'
      fullPath: '/order/$orderId/arrive'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftArriveImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/_draft/boxes': {
      id: '/_auth/order/$orderId/_order/_draft/boxes'
      path: '/boxes'
      fullPath: '/order/$orderId/boxes'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftBoxesImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/_draft/date': {
      id: '/_auth/order/$orderId/_order/_draft/date'
      path: '/date'
      fullPath: '/order/$orderId/date'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftDateImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/_draft/depart': {
      id: '/_auth/order/$orderId/_order/_draft/depart'
      path: '/depart'
      fullPath: '/order/$orderId/depart'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftDepartImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/_draft/items': {
      id: '/_auth/order/$orderId/_order/_draft/items'
      path: '/items'
      fullPath: '/order/$orderId/items'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftItemsImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/_draft/summary': {
      id: '/_auth/order/$orderId/_order/_draft/summary'
      path: '/summary'
      fullPath: '/order/$orderId/summary'
      preLoaderRoute: typeof AuthOrderOrderIdOrderDraftSummaryImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/items/categories': {
      id: '/_auth/order/$orderId/_order/items/categories'
      path: '/items/categories'
      fullPath: '/order/$orderId/items/categories'
      preLoaderRoute: typeof AuthOrderOrderIdOrderItemsCategoriesImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/items/rooms': {
      id: '/_auth/order/$orderId/_order/items/rooms'
      path: '/items/rooms'
      fullPath: '/order/$orderId/items/rooms'
      preLoaderRoute: typeof AuthOrderOrderIdOrderItemsRoomsImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/items/categories/category': {
      id: '/_auth/order/$orderId/_order/items/categories/category'
      path: '/items/categories/category'
      fullPath: '/order/$orderId/items/categories/category'
      preLoaderRoute: typeof AuthOrderOrderIdOrderItemsCategoriesCategoryImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
    '/_auth/order/$orderId/_order/items/rooms/room': {
      id: '/_auth/order/$orderId/_order/items/rooms/room'
      path: '/items/rooms/room'
      fullPath: '/order/$orderId/items/rooms/room'
      preLoaderRoute: typeof AuthOrderOrderIdOrderItemsRoomsRoomImport
      parentRoute: typeof AuthOrderOrderIdOrderImport
    }
  }
}

// Create and export the route tree

interface AuthOrderOrderIdOrderRouteChildren {
  AuthOrderOrderIdOrderClosedRoute: typeof AuthOrderOrderIdOrderClosedRoute
  AuthOrderOrderIdOrderCompletedRoute: typeof AuthOrderOrderIdOrderCompletedRoute
  AuthOrderOrderIdOrderConfirmRoute: typeof AuthOrderOrderIdOrderConfirmRoute
  AuthOrderOrderIdOrderDraftRoute: typeof AuthOrderOrderIdOrderDraftRoute
  AuthOrderOrderIdOrderOpenRoute: typeof AuthOrderOrderIdOrderOpenRoute
  AuthOrderOrderIdOrderPayRoute: typeof AuthOrderOrderIdOrderPayRoute
  AuthOrderOrderIdOrderSubmittedRoute: typeof AuthOrderOrderIdOrderSubmittedRoute
  AuthOrderOrderIdOrderIndexRoute: typeof AuthOrderOrderIdOrderIndexRoute
  AuthOrderOrderIdOrderDraftArriveRoute: typeof AuthOrderOrderIdOrderDraftArriveRoute
  AuthOrderOrderIdOrderDraftBoxesRoute: typeof AuthOrderOrderIdOrderDraftBoxesRoute
  AuthOrderOrderIdOrderDraftDateRoute: typeof AuthOrderOrderIdOrderDraftDateRoute
  AuthOrderOrderIdOrderDraftDepartRoute: typeof AuthOrderOrderIdOrderDraftDepartRoute
  AuthOrderOrderIdOrderDraftItemsRoute: typeof AuthOrderOrderIdOrderDraftItemsRoute
  AuthOrderOrderIdOrderDraftSummaryRoute: typeof AuthOrderOrderIdOrderDraftSummaryRoute
  AuthOrderOrderIdOrderItemsCategoriesRoute: typeof AuthOrderOrderIdOrderItemsCategoriesRoute
  AuthOrderOrderIdOrderItemsRoomsRoute: typeof AuthOrderOrderIdOrderItemsRoomsRoute
  AuthOrderOrderIdOrderItemsCategoriesCategoryRoute: typeof AuthOrderOrderIdOrderItemsCategoriesCategoryRoute
  AuthOrderOrderIdOrderItemsRoomsRoomRoute: typeof AuthOrderOrderIdOrderItemsRoomsRoomRoute
}

const AuthOrderOrderIdOrderRouteChildren: AuthOrderOrderIdOrderRouteChildren = {
  AuthOrderOrderIdOrderClosedRoute: AuthOrderOrderIdOrderClosedRoute,
  AuthOrderOrderIdOrderCompletedRoute: AuthOrderOrderIdOrderCompletedRoute,
  AuthOrderOrderIdOrderConfirmRoute: AuthOrderOrderIdOrderConfirmRoute,
  AuthOrderOrderIdOrderDraftRoute: AuthOrderOrderIdOrderDraftRoute,
  AuthOrderOrderIdOrderOpenRoute: AuthOrderOrderIdOrderOpenRoute,
  AuthOrderOrderIdOrderPayRoute: AuthOrderOrderIdOrderPayRoute,
  AuthOrderOrderIdOrderSubmittedRoute: AuthOrderOrderIdOrderSubmittedRoute,
  AuthOrderOrderIdOrderIndexRoute: AuthOrderOrderIdOrderIndexRoute,
  AuthOrderOrderIdOrderDraftArriveRoute: AuthOrderOrderIdOrderDraftArriveRoute,
  AuthOrderOrderIdOrderDraftBoxesRoute: AuthOrderOrderIdOrderDraftBoxesRoute,
  AuthOrderOrderIdOrderDraftDateRoute: AuthOrderOrderIdOrderDraftDateRoute,
  AuthOrderOrderIdOrderDraftDepartRoute: AuthOrderOrderIdOrderDraftDepartRoute,
  AuthOrderOrderIdOrderDraftItemsRoute: AuthOrderOrderIdOrderDraftItemsRoute,
  AuthOrderOrderIdOrderDraftSummaryRoute:
    AuthOrderOrderIdOrderDraftSummaryRoute,
  AuthOrderOrderIdOrderItemsCategoriesRoute:
    AuthOrderOrderIdOrderItemsCategoriesRoute,
  AuthOrderOrderIdOrderItemsRoomsRoute: AuthOrderOrderIdOrderItemsRoomsRoute,
  AuthOrderOrderIdOrderItemsCategoriesCategoryRoute:
    AuthOrderOrderIdOrderItemsCategoriesCategoryRoute,
  AuthOrderOrderIdOrderItemsRoomsRoomRoute:
    AuthOrderOrderIdOrderItemsRoomsRoomRoute,
}

const AuthOrderOrderIdOrderRouteWithChildren =
  AuthOrderOrderIdOrderRoute._addFileChildren(
    AuthOrderOrderIdOrderRouteChildren,
  )

interface AuthOrderOrderIdRouteChildren {
  AuthOrderOrderIdOrderRoute: typeof AuthOrderOrderIdOrderRouteWithChildren
}

const AuthOrderOrderIdRouteChildren: AuthOrderOrderIdRouteChildren = {
  AuthOrderOrderIdOrderRoute: AuthOrderOrderIdOrderRouteWithChildren,
}

const AuthOrderOrderIdRouteWithChildren =
  AuthOrderOrderIdRoute._addFileChildren(AuthOrderOrderIdRouteChildren)

interface AuthRouteChildren {
  AuthChargeCompleteRoute: typeof AuthChargeCompleteRoute
  AuthChargeErrorRoute: typeof AuthChargeErrorRoute
  AuthCheckoutCompleteRoute: typeof AuthCheckoutCompleteRoute
  AuthCheckoutErrorRoute: typeof AuthCheckoutErrorRoute
  AuthOrdersRoute: typeof AuthOrdersRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthOfferOfferIdRoute: typeof AuthOfferOfferIdRoute
  AuthPartnerOrdersRoute: typeof AuthPartnerOrdersRoute
  AuthPartnerProfileRoute: typeof AuthPartnerProfileRoute
  AuthPartnerTermsConfirmedRoute: typeof AuthPartnerTermsConfirmedRoute
  AuthPartnerIndexRoute: typeof AuthPartnerIndexRoute
  AuthOfferOfferIdCheckoutRoute: typeof AuthOfferOfferIdCheckoutRoute
  AuthOrderOrderIdRoute: typeof AuthOrderOrderIdRouteWithChildren
  AuthPartnerOrderOrderIdRoute: typeof AuthPartnerOrderOrderIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthChargeCompleteRoute: AuthChargeCompleteRoute,
  AuthChargeErrorRoute: AuthChargeErrorRoute,
  AuthCheckoutCompleteRoute: AuthCheckoutCompleteRoute,
  AuthCheckoutErrorRoute: AuthCheckoutErrorRoute,
  AuthOrdersRoute: AuthOrdersRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthOfferOfferIdRoute: AuthOfferOfferIdRoute,
  AuthPartnerOrdersRoute: AuthPartnerOrdersRoute,
  AuthPartnerProfileRoute: AuthPartnerProfileRoute,
  AuthPartnerTermsConfirmedRoute: AuthPartnerTermsConfirmedRoute,
  AuthPartnerIndexRoute: AuthPartnerIndexRoute,
  AuthOfferOfferIdCheckoutRoute: AuthOfferOfferIdCheckoutRoute,
  AuthOrderOrderIdRoute: AuthOrderOrderIdRouteWithChildren,
  AuthPartnerOrderOrderIdRoute: AuthPartnerOrderOrderIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/link': typeof LinkRoute
  '/login': typeof LoginRoute
  '/partner-login': typeof PartnerLoginRoute
  '/charge-complete': typeof AuthChargeCompleteRoute
  '/charge-error': typeof AuthChargeErrorRoute
  '/checkout-complete': typeof AuthCheckoutCompleteRoute
  '/checkout-error': typeof AuthCheckoutErrorRoute
  '/orders': typeof AuthOrdersRoute
  '/register': typeof AuthRegisterRoute
  '/register-partner/thank-you': typeof RegisterPartnerThankYouRoute
  '/register-partner': typeof RegisterPartnerIndexRoute
  '/offer/$offerId': typeof AuthOfferOfferIdRoute
  '/partner/orders': typeof AuthPartnerOrdersRoute
  '/partner/profile': typeof AuthPartnerProfileRoute
  '/partner/terms-confirmed': typeof AuthPartnerTermsConfirmedRoute
  '/partner': typeof AuthPartnerIndexRoute
  '/offer/$offerId/checkout': typeof AuthOfferOfferIdCheckoutRoute
  '/order/$orderId': typeof AuthOrderOrderIdOrderRouteWithChildren
  '/partner/order/$orderId': typeof AuthPartnerOrderOrderIdRoute
  '/order/$orderId/closed': typeof AuthOrderOrderIdOrderClosedRoute
  '/order/$orderId/completed': typeof AuthOrderOrderIdOrderCompletedRoute
  '/order/$orderId/confirm': typeof AuthOrderOrderIdOrderConfirmRoute
  '/order/$orderId/draft': typeof AuthOrderOrderIdOrderDraftRoute
  '/order/$orderId/open': typeof AuthOrderOrderIdOrderOpenRoute
  '/order/$orderId/pay': typeof AuthOrderOrderIdOrderPayRoute
  '/order/$orderId/submitted': typeof AuthOrderOrderIdOrderSubmittedRoute
  '/order/$orderId/': typeof AuthOrderOrderIdOrderIndexRoute
  '/order/$orderId/arrive': typeof AuthOrderOrderIdOrderDraftArriveRoute
  '/order/$orderId/boxes': typeof AuthOrderOrderIdOrderDraftBoxesRoute
  '/order/$orderId/date': typeof AuthOrderOrderIdOrderDraftDateRoute
  '/order/$orderId/depart': typeof AuthOrderOrderIdOrderDraftDepartRoute
  '/order/$orderId/items': typeof AuthOrderOrderIdOrderDraftItemsRoute
  '/order/$orderId/summary': typeof AuthOrderOrderIdOrderDraftSummaryRoute
  '/order/$orderId/items/categories': typeof AuthOrderOrderIdOrderItemsCategoriesRoute
  '/order/$orderId/items/rooms': typeof AuthOrderOrderIdOrderItemsRoomsRoute
  '/order/$orderId/items/categories/category': typeof AuthOrderOrderIdOrderItemsCategoriesCategoryRoute
  '/order/$orderId/items/rooms/room': typeof AuthOrderOrderIdOrderItemsRoomsRoomRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/link': typeof LinkRoute
  '/login': typeof LoginRoute
  '/partner-login': typeof PartnerLoginRoute
  '/charge-complete': typeof AuthChargeCompleteRoute
  '/charge-error': typeof AuthChargeErrorRoute
  '/checkout-complete': typeof AuthCheckoutCompleteRoute
  '/checkout-error': typeof AuthCheckoutErrorRoute
  '/orders': typeof AuthOrdersRoute
  '/register': typeof AuthRegisterRoute
  '/register-partner/thank-you': typeof RegisterPartnerThankYouRoute
  '/register-partner': typeof RegisterPartnerIndexRoute
  '/offer/$offerId': typeof AuthOfferOfferIdRoute
  '/partner/orders': typeof AuthPartnerOrdersRoute
  '/partner/profile': typeof AuthPartnerProfileRoute
  '/partner/terms-confirmed': typeof AuthPartnerTermsConfirmedRoute
  '/partner': typeof AuthPartnerIndexRoute
  '/offer/$offerId/checkout': typeof AuthOfferOfferIdCheckoutRoute
  '/order/$orderId': typeof AuthOrderOrderIdOrderIndexRoute
  '/partner/order/$orderId': typeof AuthPartnerOrderOrderIdRoute
  '/order/$orderId/closed': typeof AuthOrderOrderIdOrderClosedRoute
  '/order/$orderId/completed': typeof AuthOrderOrderIdOrderCompletedRoute
  '/order/$orderId/confirm': typeof AuthOrderOrderIdOrderConfirmRoute
  '/order/$orderId/draft': typeof AuthOrderOrderIdOrderDraftRoute
  '/order/$orderId/open': typeof AuthOrderOrderIdOrderOpenRoute
  '/order/$orderId/pay': typeof AuthOrderOrderIdOrderPayRoute
  '/order/$orderId/submitted': typeof AuthOrderOrderIdOrderSubmittedRoute
  '/order/$orderId/arrive': typeof AuthOrderOrderIdOrderDraftArriveRoute
  '/order/$orderId/boxes': typeof AuthOrderOrderIdOrderDraftBoxesRoute
  '/order/$orderId/date': typeof AuthOrderOrderIdOrderDraftDateRoute
  '/order/$orderId/depart': typeof AuthOrderOrderIdOrderDraftDepartRoute
  '/order/$orderId/items': typeof AuthOrderOrderIdOrderDraftItemsRoute
  '/order/$orderId/summary': typeof AuthOrderOrderIdOrderDraftSummaryRoute
  '/order/$orderId/items/categories': typeof AuthOrderOrderIdOrderItemsCategoriesRoute
  '/order/$orderId/items/rooms': typeof AuthOrderOrderIdOrderItemsRoomsRoute
  '/order/$orderId/items/categories/category': typeof AuthOrderOrderIdOrderItemsCategoriesCategoryRoute
  '/order/$orderId/items/rooms/room': typeof AuthOrderOrderIdOrderItemsRoomsRoomRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/link': typeof LinkRoute
  '/login': typeof LoginRoute
  '/partner-login': typeof PartnerLoginRoute
  '/_auth/charge-complete': typeof AuthChargeCompleteRoute
  '/_auth/charge-error': typeof AuthChargeErrorRoute
  '/_auth/checkout-complete': typeof AuthCheckoutCompleteRoute
  '/_auth/checkout-error': typeof AuthCheckoutErrorRoute
  '/_auth/orders': typeof AuthOrdersRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/register-partner/thank-you': typeof RegisterPartnerThankYouRoute
  '/register-partner/': typeof RegisterPartnerIndexRoute
  '/_auth/offer/$offerId': typeof AuthOfferOfferIdRoute
  '/_auth/partner/orders': typeof AuthPartnerOrdersRoute
  '/_auth/partner/profile': typeof AuthPartnerProfileRoute
  '/_auth/partner/terms-confirmed': typeof AuthPartnerTermsConfirmedRoute
  '/_auth/partner/': typeof AuthPartnerIndexRoute
  '/_auth/offer/$offerId/checkout': typeof AuthOfferOfferIdCheckoutRoute
  '/_auth/order/$orderId': typeof AuthOrderOrderIdRouteWithChildren
  '/_auth/order/$orderId/_order': typeof AuthOrderOrderIdOrderRouteWithChildren
  '/_auth/partner/order/$orderId': typeof AuthPartnerOrderOrderIdRoute
  '/_auth/order/$orderId/_order/closed': typeof AuthOrderOrderIdOrderClosedRoute
  '/_auth/order/$orderId/_order/completed': typeof AuthOrderOrderIdOrderCompletedRoute
  '/_auth/order/$orderId/_order/confirm': typeof AuthOrderOrderIdOrderConfirmRoute
  '/_auth/order/$orderId/_order/draft': typeof AuthOrderOrderIdOrderDraftRoute
  '/_auth/order/$orderId/_order/open': typeof AuthOrderOrderIdOrderOpenRoute
  '/_auth/order/$orderId/_order/pay': typeof AuthOrderOrderIdOrderPayRoute
  '/_auth/order/$orderId/_order/submitted': typeof AuthOrderOrderIdOrderSubmittedRoute
  '/_auth/order/$orderId/_order/': typeof AuthOrderOrderIdOrderIndexRoute
  '/_auth/order/$orderId/_order/_draft/arrive': typeof AuthOrderOrderIdOrderDraftArriveRoute
  '/_auth/order/$orderId/_order/_draft/boxes': typeof AuthOrderOrderIdOrderDraftBoxesRoute
  '/_auth/order/$orderId/_order/_draft/date': typeof AuthOrderOrderIdOrderDraftDateRoute
  '/_auth/order/$orderId/_order/_draft/depart': typeof AuthOrderOrderIdOrderDraftDepartRoute
  '/_auth/order/$orderId/_order/_draft/items': typeof AuthOrderOrderIdOrderDraftItemsRoute
  '/_auth/order/$orderId/_order/_draft/summary': typeof AuthOrderOrderIdOrderDraftSummaryRoute
  '/_auth/order/$orderId/_order/items/categories': typeof AuthOrderOrderIdOrderItemsCategoriesRoute
  '/_auth/order/$orderId/_order/items/rooms': typeof AuthOrderOrderIdOrderItemsRoomsRoute
  '/_auth/order/$orderId/_order/items/categories/category': typeof AuthOrderOrderIdOrderItemsCategoriesCategoryRoute
  '/_auth/order/$orderId/_order/items/rooms/room': typeof AuthOrderOrderIdOrderItemsRoomsRoomRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/link'
    | '/login'
    | '/partner-login'
    | '/charge-complete'
    | '/charge-error'
    | '/checkout-complete'
    | '/checkout-error'
    | '/orders'
    | '/register'
    | '/register-partner/thank-you'
    | '/register-partner'
    | '/offer/$offerId'
    | '/partner/orders'
    | '/partner/profile'
    | '/partner/terms-confirmed'
    | '/partner'
    | '/offer/$offerId/checkout'
    | '/order/$orderId'
    | '/partner/order/$orderId'
    | '/order/$orderId/closed'
    | '/order/$orderId/completed'
    | '/order/$orderId/confirm'
    | '/order/$orderId/draft'
    | '/order/$orderId/open'
    | '/order/$orderId/pay'
    | '/order/$orderId/submitted'
    | '/order/$orderId/'
    | '/order/$orderId/arrive'
    | '/order/$orderId/boxes'
    | '/order/$orderId/date'
    | '/order/$orderId/depart'
    | '/order/$orderId/items'
    | '/order/$orderId/summary'
    | '/order/$orderId/items/categories'
    | '/order/$orderId/items/rooms'
    | '/order/$orderId/items/categories/category'
    | '/order/$orderId/items/rooms/room'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/link'
    | '/login'
    | '/partner-login'
    | '/charge-complete'
    | '/charge-error'
    | '/checkout-complete'
    | '/checkout-error'
    | '/orders'
    | '/register'
    | '/register-partner/thank-you'
    | '/register-partner'
    | '/offer/$offerId'
    | '/partner/orders'
    | '/partner/profile'
    | '/partner/terms-confirmed'
    | '/partner'
    | '/offer/$offerId/checkout'
    | '/order/$orderId'
    | '/partner/order/$orderId'
    | '/order/$orderId/closed'
    | '/order/$orderId/completed'
    | '/order/$orderId/confirm'
    | '/order/$orderId/draft'
    | '/order/$orderId/open'
    | '/order/$orderId/pay'
    | '/order/$orderId/submitted'
    | '/order/$orderId/arrive'
    | '/order/$orderId/boxes'
    | '/order/$orderId/date'
    | '/order/$orderId/depart'
    | '/order/$orderId/items'
    | '/order/$orderId/summary'
    | '/order/$orderId/items/categories'
    | '/order/$orderId/items/rooms'
    | '/order/$orderId/items/categories/category'
    | '/order/$orderId/items/rooms/room'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/link'
    | '/login'
    | '/partner-login'
    | '/_auth/charge-complete'
    | '/_auth/charge-error'
    | '/_auth/checkout-complete'
    | '/_auth/checkout-error'
    | '/_auth/orders'
    | '/_auth/register'
    | '/register-partner/thank-you'
    | '/register-partner/'
    | '/_auth/offer/$offerId'
    | '/_auth/partner/orders'
    | '/_auth/partner/profile'
    | '/_auth/partner/terms-confirmed'
    | '/_auth/partner/'
    | '/_auth/offer/$offerId/checkout'
    | '/_auth/order/$orderId'
    | '/_auth/order/$orderId/_order'
    | '/_auth/partner/order/$orderId'
    | '/_auth/order/$orderId/_order/closed'
    | '/_auth/order/$orderId/_order/completed'
    | '/_auth/order/$orderId/_order/confirm'
    | '/_auth/order/$orderId/_order/draft'
    | '/_auth/order/$orderId/_order/open'
    | '/_auth/order/$orderId/_order/pay'
    | '/_auth/order/$orderId/_order/submitted'
    | '/_auth/order/$orderId/_order/'
    | '/_auth/order/$orderId/_order/_draft/arrive'
    | '/_auth/order/$orderId/_order/_draft/boxes'
    | '/_auth/order/$orderId/_order/_draft/date'
    | '/_auth/order/$orderId/_order/_draft/depart'
    | '/_auth/order/$orderId/_order/_draft/items'
    | '/_auth/order/$orderId/_order/_draft/summary'
    | '/_auth/order/$orderId/_order/items/categories'
    | '/_auth/order/$orderId/_order/items/rooms'
    | '/_auth/order/$orderId/_order/items/categories/category'
    | '/_auth/order/$orderId/_order/items/rooms/room'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LinkRoute: typeof LinkRoute
  LoginRoute: typeof LoginRoute
  PartnerLoginRoute: typeof PartnerLoginRoute
  RegisterPartnerThankYouRoute: typeof RegisterPartnerThankYouRoute
  RegisterPartnerIndexRoute: typeof RegisterPartnerIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LinkRoute: LinkRoute,
  LoginRoute: LoginRoute,
  PartnerLoginRoute: PartnerLoginRoute,
  RegisterPartnerThankYouRoute: RegisterPartnerThankYouRoute,
  RegisterPartnerIndexRoute: RegisterPartnerIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/link",
        "/login",
        "/partner-login",
        "/register-partner/thank-you",
        "/register-partner/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/charge-complete",
        "/_auth/charge-error",
        "/_auth/checkout-complete",
        "/_auth/checkout-error",
        "/_auth/orders",
        "/_auth/register",
        "/_auth/offer/$offerId",
        "/_auth/partner/orders",
        "/_auth/partner/profile",
        "/_auth/partner/terms-confirmed",
        "/_auth/partner/",
        "/_auth/offer/$offerId/checkout",
        "/_auth/order/$orderId",
        "/_auth/partner/order/$orderId"
      ]
    },
    "/link": {
      "filePath": "link.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/partner-login": {
      "filePath": "partner-login.tsx"
    },
    "/_auth/charge-complete": {
      "filePath": "_auth/charge-complete.tsx",
      "parent": "/_auth"
    },
    "/_auth/charge-error": {
      "filePath": "_auth/charge-error.tsx",
      "parent": "/_auth"
    },
    "/_auth/checkout-complete": {
      "filePath": "_auth/checkout-complete.tsx",
      "parent": "/_auth"
    },
    "/_auth/checkout-error": {
      "filePath": "_auth/checkout-error.tsx",
      "parent": "/_auth"
    },
    "/_auth/orders": {
      "filePath": "_auth/orders.tsx",
      "parent": "/_auth"
    },
    "/_auth/register": {
      "filePath": "_auth/register.tsx",
      "parent": "/_auth"
    },
    "/register-partner/thank-you": {
      "filePath": "register-partner/thank-you.tsx"
    },
    "/register-partner/": {
      "filePath": "register-partner/index.tsx"
    },
    "/_auth/offer/$offerId": {
      "filePath": "_auth/offer_.$offerId.tsx",
      "parent": "/_auth"
    },
    "/_auth/partner/orders": {
      "filePath": "_auth/partner_/orders.tsx",
      "parent": "/_auth"
    },
    "/_auth/partner/profile": {
      "filePath": "_auth/partner_/profile.tsx",
      "parent": "/_auth"
    },
    "/_auth/partner/terms-confirmed": {
      "filePath": "_auth/partner_/terms-confirmed.tsx",
      "parent": "/_auth"
    },
    "/_auth/partner/": {
      "filePath": "_auth/partner_/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/offer/$offerId/checkout": {
      "filePath": "_auth/offer_.$offerId_.checkout.tsx",
      "parent": "/_auth"
    },
    "/_auth/order/$orderId": {
      "filePath": "_auth/order_.$orderId",
      "parent": "/_auth",
      "children": [
        "/_auth/order/$orderId/_order"
      ]
    },
    "/_auth/order/$orderId/_order": {
      "filePath": "_auth/order_.$orderId/_order.tsx",
      "parent": "/_auth/order/$orderId",
      "children": [
        "/_auth/order/$orderId/_order/closed",
        "/_auth/order/$orderId/_order/completed",
        "/_auth/order/$orderId/_order/confirm",
        "/_auth/order/$orderId/_order/draft",
        "/_auth/order/$orderId/_order/open",
        "/_auth/order/$orderId/_order/pay",
        "/_auth/order/$orderId/_order/submitted",
        "/_auth/order/$orderId/_order/",
        "/_auth/order/$orderId/_order/_draft/arrive",
        "/_auth/order/$orderId/_order/_draft/boxes",
        "/_auth/order/$orderId/_order/_draft/date",
        "/_auth/order/$orderId/_order/_draft/depart",
        "/_auth/order/$orderId/_order/_draft/items",
        "/_auth/order/$orderId/_order/_draft/summary",
        "/_auth/order/$orderId/_order/items/categories",
        "/_auth/order/$orderId/_order/items/rooms",
        "/_auth/order/$orderId/_order/items/categories/category",
        "/_auth/order/$orderId/_order/items/rooms/room"
      ]
    },
    "/_auth/partner/order/$orderId": {
      "filePath": "_auth/partner_/order_.$orderId.tsx",
      "parent": "/_auth"
    },
    "/_auth/order/$orderId/_order/closed": {
      "filePath": "_auth/order_.$orderId/_order/closed.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/completed": {
      "filePath": "_auth/order_.$orderId/_order/completed.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/confirm": {
      "filePath": "_auth/order_.$orderId/_order/confirm.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/draft": {
      "filePath": "_auth/order_.$orderId/_order/draft.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/open": {
      "filePath": "_auth/order_.$orderId/_order/open.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/pay": {
      "filePath": "_auth/order_.$orderId/_order/pay.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/submitted": {
      "filePath": "_auth/order_.$orderId/_order/submitted.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/": {
      "filePath": "_auth/order_.$orderId/_order/index.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/_draft/arrive": {
      "filePath": "_auth/order_.$orderId/_order/_draft/arrive.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/_draft/boxes": {
      "filePath": "_auth/order_.$orderId/_order/_draft/boxes.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/_draft/date": {
      "filePath": "_auth/order_.$orderId/_order/_draft/date.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/_draft/depart": {
      "filePath": "_auth/order_.$orderId/_order/_draft/depart.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/_draft/items": {
      "filePath": "_auth/order_.$orderId/_order/_draft/items.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/_draft/summary": {
      "filePath": "_auth/order_.$orderId/_order/_draft/summary.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/items/categories": {
      "filePath": "_auth/order_.$orderId/_order/items_/categories.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/items/rooms": {
      "filePath": "_auth/order_.$orderId/_order/items_/rooms.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/items/categories/category": {
      "filePath": "_auth/order_.$orderId/_order/items_/categories_.category.tsx",
      "parent": "/_auth/order/$orderId/_order"
    },
    "/_auth/order/$orderId/_order/items/rooms/room": {
      "filePath": "_auth/order_.$orderId/_order/items_/rooms_.room.tsx",
      "parent": "/_auth/order/$orderId/_order"
    }
  }
}
ROUTE_MANIFEST_END */
